<div class="user-management-result">
  <div class="container-fluid">
    <div class="bg-white p-3 mt-2">
      <div class="row">
        <div class="col-md-5 col-sm-12">
          <h4>
            User Management
            <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>-->
          </h4>
        </div>
        <div class="col-md-7 col-sm-12 text-end">
          <div class="row g-3 flex justify-content-end">
            <div class="col-auto">
              <div class="custom-search-section">
                <app-search-box placeholder="Search..." (searchChange)="applyFilter($event)">
                </app-search-box>
              </div>
            </div>
            <div class="col-auto">
              <button type="button" class="btn h-btn-search-box btn-primary btn-sm" (click)="goToAddEditPage(null)">
                <i class="fa fa-plus"></i> Add User
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="table-responsive data-grid mt-4 sticky-header-table sticky-header-table-height-xlg full-height" >
        <table mat-table
        [dataSource]="dataSource"        
        class="table table-hover"
        matSort
        infiniteScroll
        [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="20"
        
        [fromRoot]="true"
        (scrolled)="onTableScroll()">
          <!-- Username Column -->
          <ng-container matColumnDef="userImage">
            <th mat-header-cell
                class="sale-image-heading"
                *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element"  (click)="goToAddEditPage(element)" class="py-2 cursor-pointer">
              <img [src]="element?.image"
                   *ngIf="isImageUrl(element?.image); else placeholder"
                   width="34" class="border rounded-0" />

              <ng-template #placeholder>
                <i class="fa fa-user-circle fa-2x"></i>
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="username">
            <th mat-header-cell
                class="clinic-heading cursor-pointer"
                
                (click)="sortTable(userTableFields.USER_NAME)"
                *matHeaderCellDef>
              User Name <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell class="cursor-pointer" (click)="goToAddEditPage(element)" *matCellDef="let element">{{ element?.username }}</td>
          </ng-container>

          <!-- Full Name Column -->
          <ng-container matColumnDef="memberName">
            <th mat-header-cell
                class="name-heading cursor-pointer"
                (click)="sortTable(userTableFields.FIRST_NAME)"
                *matHeaderCellDef>
              Name <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell class="cursor-pointer" (click)="goToAddEditPage(element)" *matCellDef="let element">{{ element?.firstName }} {{ element?.lastName }}</td>
          </ng-container>

          <!-- Email Column -->
          <ng-container matColumnDef="emailId">
            <th mat-header-cell
                class="email-heading cursor-pointer"
                (click)="sortTable(userTableFields.EMAIL_ID)"
                *matHeaderCellDef>
              Email <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell class="cursor-pointer" (click)="goToAddEditPage(element)" *matCellDef="let element">{{ element?.emailId }}</td>
          </ng-container>

          <!-- IsAdmin Column -->
          <ng-container matColumnDef="userRole">
            <th mat-header-cell
                class="admin-heading cursor-pointer"
                (click)="sortTable(userTableFields.USER_ROLE)"
                *matHeaderCellDef>
              Role <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell class="cursor-pointer" (click)="goToAddEditPage(element)" *matCellDef="let element">{{ element?.userRole }}</td>
          </ng-container>

          <!-- PhoneNumber Column -->
          <ng-container matColumnDef="phoneNumber">
            <th mat-header-cell
                class="phone-heading cursor-pointer"
                (click)="sortTable(userTableFields.PHONE_NUMBER)"
                *matHeaderCellDef>
              Phone <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell class="cursor-pointer" (click)="goToAddEditPage(element)" *matCellDef="let element">{{ element?.countryCode }}{{ element?.phoneNumber }}</td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell
                class="action-heading "
                *matHeaderCellDef>
              Actions
            </th>
            <td mat-cell *matCellDef="let element" class="custom-dropdown-menu ps-4" ngbDropdown>
              <div class="dropdown-toggl cursor-pointer inline-element mr-10"
                   id="action-dropdown"
                   ngbDropdownToggle>
                <i class="fas fa-ellipsis-v"></i>
              </div>
              <div class="action-dropdown fs-13"
                   ngbDropdownMenu
                   aria-labelledby="action-dropdown">

                <button (click)="goToAddEditPage(element)"
                        ngbDropdownItem>
                  Edit User
                </button>
                <button ngbDropdownItem
                        (click)="updateResetPassword(element)">
                  Reset Password
                </button>
              </div>

            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns$.value; sticky: true"></tr>
          <tr mat-row
              *matRowDef="
              let row;
              columns: displayedColumns$.value;
              let vetUserIndex = index
            "
              class="border-start-0 border-end-0 pointer pt-2 tr-fs-13px"></tr>
        </table>

        <!--<div class="col-md-12 text-center" *ngIf="isLoader">
          Loading <i class="fa fa-spinner fa-spin"></i>
        </div>-->
      </div>
    </div>
  </div>
</div>
